import calculateDistance from './calculateDistance';

export default function sortByDistance(locations, lat, lon) {
  // Calculate the distance for each location and add it as a new property
  locations.forEach(location => {
    const distance = calculateDistance(lat, lon, location.Latitude, location.Longitude);
    location.distance = distance;
  });

  // Sort the locations based on distance
  locations.sort((a, b) => a.distance - b.distance);

  // Remove the distance property from the sorted array if needed
  locations.forEach(location => {
    delete location.distance;
  });

  return locations;
}
